/* src/app/login/login.component.css */
div#sub_page_content {
  height: 100%;
  min-height: 100%;
}
#login_top_spacing {
  min-height: 20%;
  height: 20%;
  display: block;
}
#footer_text {
  color: #e4e4e4;
}
#footer_text .btn {
  background: none;
  border: none;
  min-width: 72px;
  min-height: 40px;
}
#footer_text .btn:hover,
#footer_text .btn:active,
#footer_text .btn:focus {
  color: #ffe787;
  font-weight: 600;
  outline: none;
}
#login_form {
  background-color: #ffffff;
  border: 2px solid #174F8D;
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr="#d9174F8D", endColorstr="#d9174F8D");
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 500px;
  min-height: 398px;
  max-width: 350px;
  padding: 48px 28px 10px;
  border-radius: 0;
}
.login-fieldset {
  background-color: white;
  width: 340px;
  right: 23px;
  position: relative;
}
#username_box {
  margin-bottom: 16px;
}
#username_box input {
  outline: none;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  text-align: right;
}
#username_box input::-webkit-input-placeholder {
  text-align: right;
}
#username_box input:-moz-placeholder {
  text-align: right;
}
#username_box input::-moz-placeholder {
  text-align: right;
}
#username_box input:-ms-input-placeholder {
  text-align: right;
}
.form-control-login {
  height: 30px;
  padding-left: 20px;
  margin-top: -25px;
}
#password_box {
  margin-bottom: 16px;
}
#password_box input {
  outline: none;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  text-align: right;
}
.self-enroll {
  font-family:
    Open Sans,
    Arial,
    sans-serif;
  font-weight: normal;
  font-size: 10pt;
  color: #ffffff;
}
#password_box input::-webkit-input-placeholder {
  text-align: right;
}
#password_box input:-moz-placeholder {
  text-align: right;
}
#password_box input::-moz-placeholder {
  text-align: right;
}
#password_box input:-ms-input-placeholder {
  text-align: right;
}
button#login_button {
  height: 40px;
  width: 264px;
  margin: 40px auto 20px;
  background-color: #336A97;
  border-style: solid;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  -webkit-box-shadow: 0 2px 2px 0 rgba(28, 49, 73, 0.65);
  -moz-box-shadow: 0 2px 2px 0 rgba(28, 49, 73, 0.65);
  box-shadow: 0 2px 2px 0 rgba(28, 49, 73, 0.65);
  filter: progid:DXImageTransform.Microsoft.dropshadow(OffX=0, OffY=2, Color="#A61C3149");
}
button#login_buttonTwo {
  height: 40px;
  width: 264px;
  margin: 10px auto;
  background-color: #ffffff;
  border-style: solid;
  border-color: #336a97;
  border-radius: 8px;
  border-width: 2px;
  font-weight: 600;
  -webkit-box-shadow: 0 2px 2px 0 rgba(28, 49, 73, 0.65);
  -moz-box-shadow: 0 2px 2px 0 rgba(28, 49, 73, 0.65);
  box-shadow: 0 2px 2px 0 rgba(28, 49, 73, 0.65);
  filter: progid:DXImageTransform.Microsoft.dropshadow(OffX=0, OffY=2, Color="#A61C3149");
}
button#login_button:hover {
  background-color: #003764;
}
button#login_button:focus {
  background-color: #336a97;
  outline-offset: 6px;
  outline: #336a97 solid 3px;
}
button#login_button[disabled] {
  box-shadow: none;
  opacity: 1;
  background-color: #c9c9c9;
  color: white;
}
button#login_buttonTwo:hover {
  color: #003764;
  border-color: #003764;
}
button#login_buttonTwo:focus {
  color: #336a97;
  border-color: #336a97;
  outline-offset: 6px;
  outline: #336a97 solid 3px;
}
button#login_buttonTwo:disabled {
  color: #c9c9c9;
  border-color: #c9c9c9;
}
.cookiePolicy {
  color: #e4e4e4;
  text-align: center;
  display: block;
  font-size: 9px;
  margin-bottom: 10px;
}
.cookiePolicy a {
  color: #e4e4e4;
}
.cookiePolicy a:hover {
  color: #ffe787;
}
.sessionExpired {
  color: #d3564d;
  margin-bottom: -20px;
}
#register_text {
  height: 100%;
  margin: 0 auto;
}
#register_text > a {
  color: #e4e4e4;
  font-weight: 400;
}
#register_text > a:active,
#register_text > a:focus,
#register_text > a:hover {
  color: #ffe787;
  text-decoration: none;
}
#military_seals {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 246px;
  margin-top: -55px;
}
.termsAndConditions {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 8pt;
  color: #ffffff;
  text-decoration: underline;
}
a.termsAndConditions:hover {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 8pt;
  color: #ffffff;
  text-decoration: none;
}
hr {
  border-color: white;
}
.enroll {
  color: #ffeea9;
  text-decoration: underline;
}
.banner {
  background-color: #A03232;
  color: white;
  font-size: 13pt;
  padding: 1%;
  width: calc(100% + 45px);
  margin-left: -15px;
  text-align: center;
}
.helpLink {
  text-decoration: underline;
  color: white;
}
.login-side-card {
  width: 160px;
  height: auto;
  margin-top: 240px;
}
.login-side-card-left {
  margin-right: 40px;
}
.login-side-card-right {
  margin-left: 40px;
}
@media (max-width: 768px) {
  .login-side-card {
    display: none;
  }
}
.combined-logo-login {
  height: 125px;
  width: 125px;
  object-fit: contain;
  margin-top: -35px;
  margin-bottom: 5px;
}
.logo-caption {
  text-align: center;
  color: #003764;
  font-family: Open Sans, sans-serif;
  margin-top: 10px;
  margin-bottom: 0;
}
/*# sourceMappingURL=login.component.css.map */
